import { useRef, useState } from "react";
import { supabase } from "../lib/supabase";

export type EngineEstimateTarget = {
  itemId: string; estimateId: string; estimateName: string;
  code: string | null; description: string; unit: string | null;
};

export default function SaveParametricDraft({ target, snapshot, canSave, pricesReady, onReturn }: {
  target: EngineEstimateTarget | null;
  snapshot: Record<string, unknown>;
  canSave: boolean; pricesReady: boolean; onReturn: () => void;
}) {
  const [busy, setBusy] = useState(false);
  const saving = useRef(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  async function save() {
    if (!target || !canSave || !pricesReady || saving.current) return;
    saving.current = true; setBusy(true); setError(""); setMessage("");
    try {
      const { error: saveError } = await supabase.rpc("save_parametric_estimate_draft", {
        item_id: target.itemId, snapshot,
      });
      if (saveError) throw saveError;
      setMessage("Rascunho guardado na proposta. Consulte-o em Orçamentação. Cada gravação conserva uma versão.");
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : String((cause as { message?: string }).message ?? cause));
    } finally { saving.current = false; setBusy(false); }
  }
  return <section className="card engine-parameters">
    <h3>Guardar na proposta</h3>
    {target ? <>
      <p><strong>{target.estimateName}</strong> · {target.code || "Sem código"} · {target.unit || "Sem unidade"}</p>
      <p>{target.description}</p>
      <p className="muted">Fica guardado como cálculo incompleto, com parâmetros, recursos e origem dos valores. O preço da proposta só poderá ser aplicado depois de completar e validar a composição.</p>
      {canSave ? <button className="button button-primary" type="button" disabled={busy || !pricesReady}
        onClick={() => void save()}>{busy ? "A guardar…" : "Guardar rascunho incompleto"}</button> : null}
    </> : <p className="muted">Abra um artigo em Orçamentação através de «Calcular no Gerador» para guardar o cálculo nessa proposta.</p>}
    <button className="button button-secondary" type="button" onClick={onReturn}>Voltar à Orçamentação</button>
    {error ? <div className="alert alert-error">{error}</div> : null}
    {message ? <div className="alert alert-success">{message}</div> : null}
  </section>;
}
